<template>
  <div class="home">
    <a class="home__brand" href="https://monitive.com">
      <img class="home__logo" alt="Monitive logo" src="../assets/logo.png" />
      <img
        class="home__name"
        alt="Monitive"
        src="../assets/monitive-text.png"
      />
    </a>
    <p>
      To find out first when your website is down, go to
      <a href="https://monitive.com">monitive.com</a>.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.home {
  text-align: center;
  margin-top: 10rem;
  &__brand {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__logo {
    max-width: 5rem;
    margin-right: 1rem;
  }
  p {
    padding: 2rem 0 4rem;
  }
}
</style>
